module.exports = __webpack_public_path__ + "img/empty.986baf04.png";